'use strict';

var angularModule = angular.module('t2g.common.data-access.appointment', []);

module.exports = angularModule;

angularModule.factory('AppointmentResource', function($resource, settings) {
  // /appointment/:appointmentId/participants/:customerId

  var resourceUrl =
    settings.apiBase + '/api/v2/appointment/:appointmentId/:subResource1/:subResource2';

  return $resource(
    resourceUrl,
    {},
    {
      get: { method: 'get' },
      insert: { method: 'post' },
      remove: { method: 'delete' },
      removeSynced: { method: 'delete', params: { appointmentId: 'sync' } },
      getSyncedAndUnlinked: { method: 'get', params: { appointmentId: 'sync' } },
      removeSyncedAndUnlinked: { method: 'delete', params: { appointmentId: 'sync' } },
      getGoogleSyncedAndUnlinked: { method: 'get', params: { appointmentId: 'sync-google' } },
      removeGoogleSyncedAndUnlinked: { method: 'delete', params: { appointmentId: 'sync-google' } },
      update: { method: 'put', params: { appointmentId: '@_id' } },
      addParticipant: { method: 'post', params: { subResource1: 'participants' } },
      removeParticipant: { method: 'delete', params: { subResource1: 'participants' } },
    },
  );
});

angularModule.factory('AppointmentDA', function(
  $q,
  AppointmentResource,
  CalendarDA,
  gettextCatalog,
  Notification,
) {
  return {
    addParticipant: addParticipant,
    removeParticipant: removeParticipant,
    get: get,
    insert: insert,
    remove: remove,
    removeSyncedViaICal: removeSyncedViaICal,
    getSyncedAndUnlinked: getSyncedAndUnlinked,
    removeSyncedAndUnlinked: removeSyncedAndUnlinked,
    getGoogleSyncedAndUnlinked: getGoogleSyncedAndUnlinked,
    removeGoogleSyncedAndUnlinked: removeGoogleSyncedAndUnlinked,
    update: update,
    transformResponse: transformResponse,
  };

  /**
   * parse appointment start and end als date times
   * @param {Object} response
   * @returns {Object}
   */
  function transformResponse(response) {
    var appointments = response.appointments || response.appointment || response;

    _.map(appointments, function(appointment) {
      appointment.start = new Date(appointment.start);
      appointment.end = new Date(appointment.end);
      appointment.preparationStart = appointment.preparationStart
        ? new Date(appointment.preparationStart)
        : appointment.start;
      appointment.followUpEnd = appointment.followUpEnd
        ? new Date(appointment.followUpEnd)
        : appointment.end;
      return appointment;
    });

    return appointments;
  }

  /**
   * add a participant to a course appointment
   *
   * @param {String} appointmentId
   * @param {String} customerId
   * @returns {promise}
   */
  function addParticipant(appointmentId, customerId) {
    return AppointmentResource.addParticipant(
      { appointmentId: appointmentId },
      { participant: customerId },
    )
      .$promise.then(transformResponse)
      .then(function(updatedAppointment) {
        Notification.addSuccessMessage(gettextCatalog.getString('Appointment updated'));
        return CalendarDA.editAppointment(updatedAppointment);
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant update appointment'));
      });
  }

  /**
   * remove a participant to a course appointment
   *
   * @param {String} appointmentId
   * @param {String} customerId
   * @returns {promise}
   */
  function removeParticipant(appointmentId, customerId) {
    return AppointmentResource.removeParticipant({
      appointmentId: appointmentId,
      subResource2: customerId,
    })
      .$promise.then(transformResponse)
      .then(function(updatedAppointment) {
        Notification.addSuccessMessage(gettextCatalog.getString('Appointment updated'));
        return CalendarDA.editAppointment(updatedAppointment);
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant update appointment'));
      });
  }

  /**
   * get an appointment
   * @param {String} appointmentId
   * @returns {Object}
   */
  function get(appointmentId) {
    return AppointmentResource.get({ appointmentId: appointmentId }).$promise.then(function(
      response,
    ) {
      var appointment = response.appointment;
      appointment.start = new Date(appointment.start);
      appointment.end = new Date(appointment.end);
      appointment.preparationStart = new Date(appointment.preparationStart);
      appointment.followUpEnd = new Date(appointment.followUpEnd);
      return appointment;
    });
  }

  /**
   * save appointment
   * @param appointment
   * @returns {Object}
   */
  function insert(appointment) {
    return AppointmentResource.insert(appointment)
      .$promise.then(transformResponse)
      .then(function(insertedAppointment) {
        Notification.addSuccessMessage(gettextCatalog.getString('Appointment saved'));
        return CalendarDA.insertAppointment(insertedAppointment);
      })
      .then(function(insertedAppointments) {
        var firstAppointment = insertedAppointments[0];

//        if (firstAppointment && firstAppointment.customerNotified) {
//          Notification.addSuccessMessage(
//            gettextCatalog.getString('Notification email send to {{customerEmail}}', {
//              customerEmail: firstAppointment.customer.email,
//            }),
//          );
//        }

        return insertedAppointments;
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant save appointment'));
      });
  }

  /**
   * delete an appointment
   *
   * @param {String} appointmentId
   * @param {Boolean} sendNotification
   * @param {Object} appointment
   * @returns {Object}
   */
  function remove(appointmentId, sendNotification, appointment) {
    return AppointmentResource.remove({
      appointmentId: appointmentId,
      sendNotification: sendNotification === true ? 'true' : false,
    })
      .$promise.then(function() {
        Notification.addSuccessMessage(gettextCatalog.getString('Appointment deleted'));

//        if (sendNotification) {
//          Notification.addSuccessMessage(
//            gettextCatalog.getString('Notification email send to {{customerEmail}}', {
//              customerEmail: _.get(appointment, 'customer.email'),
//            }),
//          );
//        }

        if (appointment.seriesId) return CalendarDA.removeAppointment(appointmentId);
        return CalendarDA.removeAppointmentGroup(appointment._id);
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant delete appointment'));
      });
  }

  /**
   * delete all synced appointments related to sync calendar
   *
   * @param {String} employeeId
   * @param {String} syncId
   * @returns {Object}
   */
  function removeSyncedViaICal(employeeId, syncId) {
    return AppointmentResource.removeSynced({ subResource1: employeeId, subResource2: syncId })
      .$promise.then(function() {
        Notification.addSuccessMessage(gettextCatalog.getString('Appointments deleted'));

        return { success: true };
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant delete appointments'));

        return { success: false };
      });
  }

  /**
   * get all synced appointments but not binded with any sync calendar
   *
   * @param {String} employeeId
   * @returns {Object}
   */
  function getSyncedAndUnlinked(employeeId) {
    return AppointmentResource.getSyncedAndUnlinked({
      subResource1: employeeId,
      subResource2: 'unlinked',
    })
      .$promise.then(function(appointments) {
        return appointments;
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant get appointments'));

        return { success: false };
      });
  }

  /**
   * get all synced appointments but not binded with any sync calendar
   *
   * @param {String} employeeId
   * @returns {Object}
   */
  function removeSyncedAndUnlinked(employeeId) {
    return AppointmentResource.removeSyncedAndUnlinked({
      subResource1: employeeId,
      subResource2: 'unlinked',
    })
      .$promise.then(function(appointments) {
        return appointments;
      })
      .catch(function(err) {
        console.log(err);
        Notification.addErrorMessage(gettextCatalog.getString('Cant remove appointments'));

        return { success: false };
      });
  }

  /**
   * get all synced appointments but not binded with any Google sync calendar
   *
   * @param {String} officeId
   * @returns {Object}
   */
  function getGoogleSyncedAndUnlinked(officeId) {
    return AppointmentResource.getGoogleSyncedAndUnlinked({
      subResource1: officeId,
      subResource2: 'unlinked',
    })
      .$promise.then(function(appointments) {
        return appointments;
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant get appointments'));

        return { success: false };
      });
  }

  /**
   * get all synced appointments but not binded with any Google sync calendar
   *
   * @param {String} officeId
   * @returns {Object}
   */
  function removeGoogleSyncedAndUnlinked(officeId) {
    return AppointmentResource.removeGoogleSyncedAndUnlinked({
      subResource1: officeId,
      subResource2: 'unlinked',
    })
      .$promise.then(function(appointments) {
        return appointments;
      })
      .catch(function(err) {
        console.log(err);
        Notification.addErrorMessage(gettextCatalog.getString('Cant remove appointments'));

        return { success: false };
      });
  }

  /**
   * update an appointment
   *
   * @param {Object} appointment
   * @param {Boolean} sendNotification
   * @returns {Object}
   */
  function update(appointment, sendNotification) {
    return AppointmentResource.update(appointment)
      .$promise.then(transformResponse)
      .then(function(updatedAppointment) {
        Notification.addSuccessMessage(gettextCatalog.getString('Appointment updated'));

        CalendarDA.removeAppointmentGroup(appointment._id);

//        if (sendNotification) {
//          Notification.addSuccessMessage(
//            gettextCatalog.getString('Notification email send to {{customerEmail}}', {
//              customerEmail: _.get(appointment, 'customer.email'),
//            }),
//          );
//        }

        return CalendarDA.editAppointment(updatedAppointment);
      })
      .catch(function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant update appointment'));
      });
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/appointment.js